import styled from 'styled-components';

import { styledScroll } from 'styles/styledScroll';

import colors from 'themes/Main';

const { white, gray01, gray02, darkBlue } = colors;

export const Content = styled.div`
  padding: 0 32px;
`;

export const Answers = styled.div``;

export const Head = styled.div`
  padding: 16px 40px;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;

  > div {
    position: absolute;
    left: 16px;
  }

  p {
    width: 50%;
    margin-bottom: 0;
  }
`;

export const AreaName = styled.p`
  font-weight: 700;
  color: ${gray01};
  padding-right: 32px;
`;

export const KnowledgeLevel = styled.p`
  font-weight: 700;
  text-transform: uppercase;
  color: ${darkBlue};
`;

export const Question = styled.div`
  position: relative;
  padding: 16px 40px;
  display: flex;
  align-items: center;
  background-color: ${white};
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  > div:first-child {
    position: absolute;
    left: 16px;
  }

  p {
    width: 50%;
    margin-bottom: 0;
  }
`;

export const Description = styled.p`
  color: ${gray01};
  padding-right: 32px;
`;

export const Knowledge = styled.p`
  color: ${darkBlue};
  font-weight: 600;

  &.type-text {
    color: ${gray02};
  }
`;

export const HasCertified = styled.div`
  width: 150px;
  position: absolute;
  right: 16px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const StickyContent = styled.div`
  ${styledScroll};
  position: sticky;
  top: 16px;
  overflow-y: auto;
  max-height: 95vh;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

export const OthersCertificates = styled.div`
  padding: 16px;
  background-color: ${white};
  border-radius: 4px;
  box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
    0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);
`;

export const InputContainer = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  svg {
    margin-right: 8px;
  }
`;

export const Small = styled.small`
  display: block;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${gray01};
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
`;
